import { useBloomreachPageModels } from "./use-bloomreach-page-models.js";
import { useSubscribeNewsletter } from "./use-subscribe-newsletter.js";
import { useBrPageContext } from "../../context/context/context.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const useBloomreachNewsletterData = () => {
  const newsletterSubscribe = useSubscribeNewsletter();
  const page = useBrPageContext();
  const pageModels = useBloomreachPageModels();
  const newsletterContent = getBrPageContent(
    page,
    pageModels?.newsletterConfiguration
  );
  const contentAfterSubmit = newsletterContent?.richTextAfter?.value;
  const contentBeforeSubmit = newsletterContent?.richTextBefore?.value;
  const title = newsletterContent?.title;
  return {
    ...newsletterSubscribe,
    contentAfterSubmit,
    contentBeforeSubmit,
    title
  };
};
export {
  useBloomreachNewsletterData
};
//# sourceMappingURL=use-bloomreach-newsletter-data.js.map
